(function(){"use strict";try{if(typeof document!="undefined"){var e=document.createElement("style");e.appendChild(document.createTextNode(".raise-hand-icon[data-v-ebb479be]{display:inline-block;flex-shrink:0;transition:all .2s ease-in-out}.variant-raised[data-v-ebb479be]{filter:drop-shadow(0 1px 2px rgba(0,0,0,.3))}.raise-hand-icon[data-v-ebb479be]:hover{transform:scale(1.05)}.reaction-icon[data-v-3abf9efd]{display:inline-block;flex-shrink:0;transition:all .2s ease-in-out}.variant-active[data-v-3abf9efd]{filter:drop-shadow(0 1px 2px rgba(0,0,0,.3))}.reaction-icon[data-v-3abf9efd]:hover{transform:scale(1.05)}.triple-dot-icon[data-v-f48fe291]{display:inline-block;vertical-align:middle;flex-shrink:0}")),document.head.appendChild(e)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import { defineComponent as a, createElementBlock as e, openBlock as s, mergeProps as r, createElementVNode as c, computed as d, normalizeClass as l, createCommentVNode as q } from "vue";
import { _ as h } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const p = ["width", "height"], y = /* @__PURE__ */ a({
  __name: "GroupUserIcon",
  props: {
    size: { default: 24 }
  },
  setup(i) {
    return (t, o) => (s(), e("svg", r({
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      focusable: "false",
      fill: "currentColor"
    }, t.$attrs), o[0] || (o[0] = [
      c("path", { d: "M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z" }, null, -1)
    ]), 16, p));
  }
}), T = ["width", "height"], B = /* @__PURE__ */ a({
  __name: "LayoutIcon",
  props: {
    size: { default: 24 }
  },
  setup(i) {
    return (t, o) => (s(), e("svg", r({
      width: t.size,
      height: t.size,
      viewBox: "0 -960 960 960",
      focusable: "false",
      fill: "currentColor"
    }, t.$attrs), o[0] || (o[0] = [
      c("path", { d: "M560-600q-17 0-28.5-11.5T520-640v-160q0-17 11.5-28.5T560-840h240q17 0 28.5 11.5T840-800v160q0 17-11.5 28.5T800-600H560ZM160-440q-17 0-28.5-11.5T120-480v-320q0-17 11.5-28.5T160-840h240q17 0 28.5 11.5T440-800v320q0 17-11.5 28.5T400-440H160Zm400 320q-17 0-28.5-11.5T520-160v-320q0-17 11.5-28.5T560-520h240q17 0 28.5 11.5T840-480v320q0 17-11.5 28.5T800-120H560Zm-400 0q-17 0-28.5-11.5T120-160v-160q0-17 11.5-28.5T160-360h240q17 0 28.5 11.5T440-320v160q0 17-11.5 28.5T400-120H160Z" }, null, -1)
    ]), 16, T));
  }
}), _ = ["width", "height"], f = ["d"], R = /* @__PURE__ */ a({
  __name: "PinIcon",
  props: {
    size: { default: 24 },
    variant: { default: "on" }
  },
  setup(i) {
    const t = i, o = {
      on: "m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40v280Z",
      off: "m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40v280Zm-286 80h252l-46-46v-314H400v314l-46 46Zm126 0Z"
    }, v = d(() => o[t.variant]);
    return (n, I) => (s(), e("svg", r({
      width: n.size,
      height: n.size,
      viewBox: "0 -960 960 960",
      focusable: "false",
      fill: "currentColor",
      style: { transform: "rotate(45deg)" }
    }, n.$attrs), [
      c("path", { d: v.value }, null, 8, f)
    ], 16, _));
  }
}), m = ["width", "height"], u = {
  key: 0,
  d: "M18.5,14.5c0,0.28-0.22,0.5-0.5,0.5l0,0c-1.51,0-2.77,1.12-2.97,2.58C15,17.82,14.78,18,14.54,18c-0.3,0-0.54-0.27-0.5-0.57 c0.26-1.77,1.68-3.17,3.46-3.4l0-10.78C17.5,2.56,16.94,2,16.25,2C15.56,2,15,2.56,15,3.25v7.25c0,0.28-0.22,0.5-0.5,0.5 S14,10.78,14,10.5V1.25C14,0.56,13.44,0,12.75,0S11.5,0.56,11.5,1.25v9.25c0,0.28-0.22,0.5-0.5,0.5s-0.5-0.22-0.5-0.5V2.75 c0-0.69-0.56-1.25-1.25-1.25S8,2.06,8,2.75v8.75C8,11.78,7.78,12,7.5,12S7,11.78,7,11.5V5.75C7,5.06,6.44,4.5,5.75,4.5 S4.5,5.06,4.5,5.75v10c0,4.56,3.69,8.25,8.25,8.25S21,20.31,21,15.75v-6.5C21,8.56,20.44,8,19.75,8S18.5,8.56,18.5,9.25V14.5z",
  fill: "#FFA726"
}, z = {
  key: 1,
  d: "M18.5,8c-0.17,0-0.34,0.02-0.5,0.05V4.5C18,3.12,16.88,2,15.5,2c-0.19,0-0.37,0.02-0.54,0.06C14.75,0.89,13.73,0,12.5,0 c-1.06,0-1.96,0.66-2.33,1.59C9.96,1.53,9.73,1.5,9.5,1.5C8.12,1.5,7,2.62,7,4v0.55C6.84,4.52,6.67,4.5,6.5,4.5C5.12,4.5,4,5.62,4,7 v8.5c0,4.69,3.81,8.5,8.5,8.5s8.5-3.81,8.5-8.5v-5C21,9.12,19.88,8,18.5,8z M19,15.5c0,3.59-2.91,6.5-6.5,6.5S6,19.09,6,15.5V7 c0-0.28,0.22-0.5,0.5-0.5S7,6.72,7,7v5h2V4c0-0.28,0.22-0.5,0.5-0.5S10,3.72,10,4v7h2V2.5C12,2.22,12.22,2,12.5,2S13,2.22,13,2.5V11 h2V4.5C15,4.22,15.22,4,15.5,4S16,4.22,16,4.5v8.92c-1.77,0.77-3,2.53-3,4.58h2c0-1.66,1.34-3,3-3v-4.5c0-0.28,0.22-0.5,0.5-0.5 s0.5,0.22,0.5,0.5V15.5z",
  fill: "white"
}, w = /* @__PURE__ */ a({
  __name: "RaiseHandIcon",
  props: {
    size: { default: 24 },
    variant: { default: "lowered" }
  },
  setup(i) {
    return (t, o) => (s(), e("svg", {
      width: t.size,
      height: t.size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: l(["raise-hand-icon", `variant-${t.variant}`])
    }, [
      t.variant === "raised" ? (s(), e("path", u)) : (s(), e("path", z))
    ], 10, m));
  }
}), D = /* @__PURE__ */ h(w, [["__scopeId", "data-v-ebb479be"]]), g = ["width", "height"], C = {
  key: 0,
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.5 6c.83 0 1.5.67 1.5 1.5S16.33 11 15.5 11 14 10.33 14 9.5 14.67 8 15.5 8zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm3.5 9.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z",
  fill: "currentColor"
}, Z = {
  key: 1,
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z",
  fill: "currentColor"
}, $ = /* @__PURE__ */ a({
  __name: "ReactionIcon",
  props: {
    size: { default: 24 },
    variant: { default: "default" }
  },
  setup(i) {
    return (t, o) => (s(), e("svg", {
      width: t.size,
      height: t.size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: l(["reaction-icon", `variant-${t.variant}`])
    }, [
      t.variant === "active" ? (s(), e("path", C)) : (s(), e("path", Z))
    ], 10, g));
  }
}), E = /* @__PURE__ */ h($, [["__scopeId", "data-v-3abf9efd"]]), S = ["height", "width", "fill"], H = {
  key: 0,
  d: "M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z"
}, M = {
  key: 1,
  d: "M480-160q-33 0-56.5-23.5T400-240q0-33 23.5-56.5T480-320q33 0 56.5 23.5T560-240q0 33-23.5 56.5T480-160Zm0-240q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm0-240q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Z"
}, V = /* @__PURE__ */ a({
  __name: "TripleDotIcon",
  props: {
    size: { default: 24 },
    color: { default: "#1f1f1f" },
    align: { default: "horizontal" }
  },
  setup(i) {
    return (t, o) => (s(), e("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: `${t.size}px`,
      width: `${t.size}px`,
      viewBox: "0 -960 960 960",
      fill: t.color,
      class: "triple-dot-icon"
    }, [
      t.align === "horizontal" ? (s(), e("path", H)) : t.align === "vertical" ? (s(), e("path", M)) : q("", !0)
    ], 8, S));
  }
}), F = /* @__PURE__ */ h(V, [["__scopeId", "data-v-f48fe291"]]);
export {
  D as R,
  F as T,
  y as _,
  B as a,
  R as b,
  E as c
};
